// SPDX-License-Identifier: AGPL-3.0-or-later
// Copyright (C) 2025-2026 Daragh Farrell

import { ReactNode } from 'react';

// Re-exported so existing importers of this module keep working; the type itself,
// the context and the hook live in ./variant (react-refresh wants this file to export
// only its component).
export type { ProductVariant } from './variant';

import { VariantContext, resolveVariant } from './variant';

interface Props {
  children: ReactNode;
}

export function VariantProvider({ children }: Props) {
  return (
    <VariantContext.Provider value={resolveVariant()}>
      {children}
    </VariantContext.Provider>
  );
}
